// extracted by mini-css-extract-plugin
module.exports = {"storyblok__header":"plp_storyblok__header__xGkv0"};